module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Déplacer des rappels",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [(!_vm.form.meeting) ? _c('el-form-item', {
    attrs: {
      "prop": "date",
      "label": "Date du rappel"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Selectionnez une date",
      "picker-options": _vm.fields.date,
      "format": "dd/MM/yyyy"
    },
    nativeOn: {
      "click": function($event) {
        _vm.form.date = null;
        _vm.form.date = _vm.moment()
      }
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Commercial",
      "prop": "user_id"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.user_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_id", $$v)
      },
      expression: "form.user_id"
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.name,
        "value": user.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.form.id !== null) ? _c('el-button', {
    directives: [{
      name: "delete",
      rawName: "v-delete:reminder",
      value: (this.form),
      expression: "this.form",
      arg: "reminder"
    }],
    staticClass: "pull-left",
    attrs: {
      "type": "danger",
      "plain": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Supprimer")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.button.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.button.text))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-740ba1d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/MoveRemindersModal.vue
// module id = 710
// module chunks = 1